import React, {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {SERVICE_PIT_STOP_TIRES, SERVICE_PIT_STOP_WHEELS, TIRES_EXCHANGE, TYPE_TIRES, TYPE_WHEELS} from "../../definition/business";
import RadioServiceItem from "./RadioServiceItem";
import TireExchange from "./TireExchange";
import PitStopExchange from "./PitStopExchange";

class TiresAndWheelsOptions extends Component {

  componentDidMount(){
    const {selectedDealer} = this.props
    this.props.dispatchCheckTiresAvailabilities({
      dealerId: selectedDealer.id,
    });
  }

  hasOption = (options, optionId) => !!options.find(o => o.id === optionId);

  render() {

    const {
      intl: {formatMessage},
      otherServices,
      tiresAvailabilities,
      createAppointmentRequest
    } = this.props;

    const {selectedOptions} = createAppointmentRequest;
    const tiresExchangeService = otherServices.find(s => s.name === TIRES_EXCHANGE);

    return <div>
      <ul className="list">
      {tiresExchangeService &&
      <li>
        <RadioServiceItem radioGroup="tiresAndWheels" item={tiresExchangeService}/>
        {tiresExchangeService.name === TIRES_EXCHANGE && this.hasOption(selectedOptions, tiresExchangeService.name) && <TireExchange/>}
      </li>
      }

    {tiresAvailabilities &&
    tiresAvailabilities.isPitStopTires &&
      <li>
        <RadioServiceItem radioGroup="tiresAndWheels" item={{name:SERVICE_PIT_STOP_TIRES, title:formatMessage({id: 'customer.journey.step.serviceMobility.pitstopTires'})}}/>
        {this.hasOption(selectedOptions, SERVICE_PIT_STOP_TIRES) && <PitStopExchange type={TYPE_TIRES}/>}
      </li>
    }
    {tiresAvailabilities &&
    tiresAvailabilities.isPitStopWheels &&
      <li>
        <RadioServiceItem radioGroup="tiresAndWheels" item={{name:SERVICE_PIT_STOP_WHEELS, title:formatMessage({id: 'customer.journey.step.serviceMobility.pitstopWheels'})}}/>
        {this.hasOption(selectedOptions, SERVICE_PIT_STOP_WHEELS) && <PitStopExchange type={TYPE_WHEELS}/>}
      </li>
      }
    </ul>
    </div>
  }

}

const mapDispatchToProps = dispatch => ({
  dispatchFetchTireBrands: params => dispatch({ type: 'FETCH.CUSTOMER_DEALER_TIRE_BRAND.REQUEST', params }),
  dispatchCheckTiresAvailabilities: params => dispatch({ type: 'FETCH.TIRES_CHECK_AVAILABILITIES.REQUEST', params }),
  addService: params => dispatch({ type: 'SAVE.ADD_SERVICE', params }),
  removeService: params => dispatch({ type: 'SAVE.REMOVE_SERVICE', params }),
});

const mapStateToProps = state => ({
  otherServices: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.otherServices,
  tiresAvailabilities: state.availabilities.tiresAvailabilities,
  createAppointmentRequest: state.createAppointmentRequest,
  selectedDealer: state.customerDealer.selectedDealer,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TiresAndWheelsOptions)
);
